module.exports = __webpack_public_path__ + "media/images/new/cta-loop-2-acee56b2a8c25066188d75c1a2bc4693.png";